import React from 'react';
import { TpPromptTaskContext, TpTaskFormData, TpTaskFormElemDef, TpTaskFormParsedElemData } from './interfaces';
import { ElemValueWrapper } from '../helpers/ElemValueWrapper';

function setInitialData(elemDef: any, ctx: TpPromptTaskContext, formData: TpTaskFormData) {
  formData.elemValues[elemDef.id] = elemDef.defaultValue;
}

function generate(
  elemDef: any,
  ctx: TpPromptTaskContext,
  formData: TpTaskFormData,
  updateElemValue: (elemId: string, newValue: any) => void,
) {
  return (
    <ElemValueWrapper elemName={elemDef.displayName}>
      <input
        id={elemDef.id}
        value={formData.elemValues[elemDef.id]}
        onChange={(ev) => {
          updateElemValue(elemDef.id, ev.target.value);
        }}
      />
    </ElemValueWrapper>
  );
}

function parseElemValue(ctx: TpPromptTaskContext, elemDef: any, input: any): TpTaskFormParsedElemData {
  if (input === null || input === undefined || input === '') {
    if (!elemDef.required) return { value: null, errorString: null };
    else return { value: null, errorString: 'Missing required field' };
  }
  if (isNaN(input) || isNaN(parseFloat(input))) return { value: null, errorString: 'Invalid number' };

  return {
    value: parseFloat(input),
    errorString: null,
  };
}

const taskFormElemNumberDef: TpTaskFormElemDef = {
  type: 'number',
  name: 'Number',
  description: 'Prompts the user for a number',
  hasData: true,
  setInitialData,
  generate,
  parseElemValue,
};

export default taskFormElemNumberDef;
